function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import warning from 'warning';
import * as styles from '../../styles/text-input';
import * as stylesWrapper from '../../styles/input-wrapper';
import { jsx as ___EmotionJSX } from "@emotion/core";
class TextInput extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      value: this.props.value || this.props.defaultValue,
      focused: false,
      formatted: this.format(this.props.value || this.props.defaultValue)
    });
    _defineProperty(this, "onChange", event => {
      var value = event.target.value;
      if (this.props.type === 'number') {
        // validity.valid only works on firefox and safari :(
        // and event.target.value is empty when input is invalid so reset it
        if (event.target.validity && !event.target.validity.valid) {
          this._inputRef.value = this.state.value;
          this.props.onChange(event);
          return;
        }
      }
      this.setState({
        value,
        formatted: this.format(value)
      });
      this.props.onChange(event);
    });
    _defineProperty(this, "onFocus", event => {
      this.setState({
        focused: true
      });
      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
    });
    _defineProperty(this, "onBlur", event => {
      this.setState({
        focused: false
      });
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(this, "focus", () => {
      this._inputRef.focus();
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(this, "blur", () => {
      this._inputRef.blur();
    });
  }
  static getDerivedStateFromProps(props, state) {
    if (state.value === undefined && props.value !== undefined || state.value !== undefined && props.value === undefined) {
      warning(false, 'The value prop of TextInput has changed between being undefined and having a value. ' + 'You should avoid letting this component go between being uncontrolled and controlled, ' + 'since it can cause unexpected behaviour. ' + 'For more details see https://github.com/domain-group/fe-co-form-elements/blob/master/docs/text-input.md#controlled-vs-uncontrolled');
    }

    // allow for controlled component
    if (typeof props.value !== 'undefined' && state.value !== props.value) {
      return {
        value: props.value,
        formatted: typeof props.format === 'function' ? props.format(props.value) : undefined
      };
    }
    return null;
  }

  /**
   * returns true if the input element is the first child inside the input wrapper. This is used for styling various
   * elements (mainly to add or remove a border-radius).
   */
  isInputFirstChild() {
    var _this$props = this.props,
      iconPosition = _this$props.iconPosition,
      iconAppearance = _this$props.iconAppearance,
      icon = _this$props.icon,
      nestedInput = _this$props.nestedInput,
      nestedInputPosition = _this$props.nestedInputPosition;

    // if the icon is displayed on the right side or the icon is displayed
    // within the input wrapper or no icon is used at all AND the nestedInput is
    // displayed on the right or not provided, the input element is the first
    // child.
    return (iconPosition === 'right' || iconAppearance === 'inside' || !icon) && (nestedInputPosition === 'right' || !nestedInput);
  }

  /**
   * Returns true if the input element is the last child in the input wrapper. This is used for styling various
   * elements (mainly to add or remove a border-radius)
   */
  isInputLastChild() {
    var _this$props2 = this.props,
      iconPosition = _this$props2.iconPosition,
      iconAppearance = _this$props2.iconAppearance,
      icon = _this$props2.icon,
      nestedInput = _this$props2.nestedInput,
      nestedInputPosition = _this$props2.nestedInputPosition;

    // if the icon is displayed on the left side or the icon is displayed
    // within the input wrapper or no icon is used at all AND the nestedInput is
    // displayed on the left or not provided, the input element is the first
    // child.
    return (iconPosition === 'left' || iconAppearance === 'inside' || !icon) && (nestedInputPosition === 'left' || !nestedInput);
  }
  componentDidUpdate(prevProps, prevState) {
    if (!prevState.focused && this.state.focused && this.state.formatted) {
      this.getInputRef().select();
    }
  }
  getValue() {
    return this.state.value;
  }
  getInputRef() {
    return this._inputRef;
  }
  format(value) {
    if (typeof this.props.format === 'function') {
      return this.props.format(value);
    }
    return value;
  }
  render() {
    var _this$props3 = this.props,
      id = _this$props3.id,
      name = _this$props3.name,
      type = _this$props3.type,
      placeholder = _this$props3.placeholder,
      disabled = _this$props3.disabled,
      autoFocus = _this$props3.autoFocus,
      isInvalid = _this$props3.isInvalid,
      className = _this$props3.className,
      onKeyDown = _this$props3.onKeyDown,
      onKeyUp = _this$props3.onKeyUp,
      icon = _this$props3.icon,
      iconPosition = _this$props3.iconPosition,
      iconAppearance = _this$props3.iconAppearance,
      nestedInput = _this$props3.nestedInput,
      nestedInputPosition = _this$props3.nestedInputPosition,
      labelAppearance = _this$props3.labelAppearance,
      multiline = _this$props3.multiline,
      rows = _this$props3.rows,
      step = _this$props3.step,
      appearance = _this$props3.appearance,
      readOnly = _this$props3.readOnly,
      size = _this$props3.size,
      pattern = _this$props3.pattern,
      inputProps = _this$props3.inputProps,
      floatingLabel = _this$props3.floatingLabel,
      inputMode = _this$props3.inputMode,
      resize = _this$props3.resize;
    var isValueRendererUsed = !multiline && typeof this.props.format === 'function';
    var displayPlaceholder = this.getValue() === '' && placeholder;
    var styleFlags = {
      isInvalid,
      isDisabled: disabled,
      isFocused: !!this.state.focused,
      isHidden: this.state.focused,
      isDisplayingPlaceholder: !!displayPlaceholder,
      hasFloatingLabel: !!floatingLabel,
      hasIcon: !!icon,
      hasNestedInput: !!nestedInput,
      hasIconLeft: iconPosition === 'left',
      isReadOnly: readOnly,
      appearance,
      iconAppearance,
      iconPosition,
      isIconInside: iconAppearance === 'inside',
      isEmpty: this.getValue() === '',
      isUsingValueRenderer: isValueRendererUsed,
      isInputFirstChild: this.isInputFirstChild(),
      isInputLastChild: this.isInputLastChild(),
      resize
    };
    var props = _objectSpread({
      id,
      name,
      type,
      step,
      placeholder,
      disabled,
      maxLength: this.props.maxLength,
      minLength: this.props.minLength,
      className: classNames('text-input__input', className, {
        ["is-".concat(appearance)]: appearance,
        'is-invalid': isInvalid,
        'is-empty': this.getValue() === '',
        'is-using-value-renderer': isValueRendererUsed
      }),
      css: styles.input(styleFlags),
      onChange: this.onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onKeyDown,
      onKeyUp,
      ref: _ref => {
        this._inputRef = _ref;
      },
      'aria-required': this.props.required,
      'aria-label': this.props['aria-label'],
      value: this.getValue(),
      readOnly,
      size,
      pattern,
      inputMode
    }, inputProps);
    var input;
    if (autoFocus) {
      props.autoFocus = true;
    }
    if (multiline) {
      input = ___EmotionJSX("textarea", _extends({}, props, {
        rows: rows
      }));
    } else {
      warning(typeof rows === 'undefined', "Setting rows without enabling multiline won't have any effect.");
      input = ___EmotionJSX("input", props);
    }
    if (labelAppearance === 'floating-label') {
      // eslint-disable-next-line no-console
      console.error('Setting floating-label is no longer supported, pass a floatingLabel boolean into InputWrapper');
    }
    var valueRendererClass = classNames('text-input__value-renderer', {
      'is-invalid': isInvalid,
      'is-disabled': disabled,
      'is-hidden': this.state.focused,
      'is-displaying-placeholder': displayPlaceholder,
      'has-floating-label': floatingLabel,
      'has-icon-left': iconPosition === 'left',
      ["is-".concat(iconAppearance)]: iconAppearance,
      ["is-".concat(iconPosition)]: iconAppearance === 'inside'
    });
    var valueRendererNode = isValueRendererUsed ? ___EmotionJSX("div", {
      "data-testid": "text-input-value-renderer",
      className: valueRendererClass,
      css: styles.valueRenderer(styleFlags)
    }, displayPlaceholder ? placeholder : this.format(props.value)) : [];
    if (icon) {
      var iconWrapClass = classNames('text-input__icon-wrap', "is-".concat(iconAppearance), {
        ["is-".concat(iconPosition)]: iconAppearance === 'inside'
      });
      var iconClass = classNames("text-input__icon is-".concat(appearance), {
        'is-disabled': disabled,
        'is-readOnly': readOnly
      });
      var iconElement = ___EmotionJSX("span", {
        className: iconClass,
        css: styles.icon(styleFlags)
      }, icon);
      return ___EmotionJSX("div", {
        className: iconWrapClass,
        css: styles.iconWrap(styleFlags)
      }, iconPosition === 'left' && iconElement, nestedInput && nestedInputPosition === 'left' && nestedInput, isValueRendererUsed ? ___EmotionJSX("div", {
        className: "text-input__wrapper",
        css: stylesWrapper.wrapper
      }, valueRendererNode, input) : input, nestedInput && nestedInputPosition === 'right' && nestedInput, iconPosition === 'right' && iconElement);
    }
    if (nestedInput) {
      var nestedInputWrapClass = classNames('text-input__icon-wrap', "is-outside");
      return ___EmotionJSX("div", {
        className: nestedInputWrapClass,
        css: styles.iconWrap(styleFlags)
      }, nestedInputPosition === 'left' && nestedInput, isValueRendererUsed ? ___EmotionJSX("div", {
        className: "text-input__wrapper",
        css: stylesWrapper.wrapper
      }, valueRendererNode, input) : input, nestedInputPosition === 'right' && nestedInput);
    }
    return isValueRendererUsed ? ___EmotionJSX("div", {
      className: "text-input__wrapper",
      css: stylesWrapper.wrapper
    }, valueRendererNode, input) : input;
  }
}
TextInput.propTypes = {
  name: PropTypes.string,
  defaultValue: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  value: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  isInvalid: PropTypes.bool,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  iconAppearance: PropTypes.oneOf(['inside', 'outside']),
  nestedInput: PropTypes.node,
  nestedInputPosition: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string,
  autoFocus: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  appearance: PropTypes.oneOf(['regular', 'small']),
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  labelAppearance: PropTypes.oneOf(['regular', 'floating-label']),
  step: PropTypes.string,
  'aria-label': PropTypes.string,
  format: PropTypes.func,
  readOnly: PropTypes.bool,
  size: PropTypes.string,
  pattern: PropTypes.string,
  inputProps: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  floatingLabel: PropTypes.bool,
  inputMode: PropTypes.string,
  resize: PropTypes.oneOf(['auto', 'horizontal', 'none', 'vertical'])
};
TextInput.defaultProps = {
  defaultValue: '',
  type: 'text',
  multiline: false,
  disabled: false,
  isInvalid: false,
  required: false,
  icon: undefined,
  iconPosition: 'left',
  iconAppearance: 'outside',
  nestedInput: undefined,
  nestedInputPosition: 'right',
  className: undefined,
  autoFocus: false,
  onChange: () => {},
  appearance: 'regular',
  labelAppearance: 'regular',
  name: undefined,
  rows: undefined,
  value: undefined,
  placeholder: undefined,
  id: undefined,
  onFocus: undefined,
  onBlur: undefined,
  onKeyDown: undefined,
  onKeyUp: undefined,
  step: undefined,
  maxLength: undefined,
  minLength: undefined,
  'aria-label': undefined,
  format: undefined,
  readOnly: false,
  size: undefined,
  pattern: undefined,
  inputProps: undefined,
  floatingLabel: false,
  inputMode: undefined,
  resize: 'auto'
};
export default TextInput;